import { createFileRoute } from "@tanstack/react-router";
import BcbsilInsurance, { config } from "@/pages/BcbsilInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbsil-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Illinois TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Illinois coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "BCBS Illinois TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Illinois coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsil-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsil-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsilInsurance />;
}
